import classNames from 'classnames'
import { Link } from 'gatsby'
import React, { useContext } from 'react'

import {
  isHyphenatedLocale,
  LocaleContext,
  TranslationKey,
} from '../../locale/i18n'
import { categoryLandingUrl } from '../../locale/pathing'
import {
  IndustryOrMaterial,
  industryOrMaterialValues,
  TypeOfTesting,
} from '../../logic/catalog'

import './CategoryListItem.scss'

export const CategoryListItem = ({
  backgroundColor = 'light',
  categoryItem,
}: {
  backgroundColor?: 'white' | 'light'
  categoryItem: IndustryOrMaterial | TypeOfTesting
}) => {
  const { locale, t } = useContext(LocaleContext)

  return (
    <Link
      to={categoryLandingUrl(locale, categoryItem)}
      className={classNames([
        'categoryListItem',
        'categoryListItem--link',
        `categoryListItem--${backgroundColor}`,
      ])}
    >
      <img
        className="h-10 w-10"
        src={`/category-icons/${categoryItem}.svg`}
        alt="" // Empty alt text because the the icon is explained by the category name below
      />
      <span
        className={classNames('categoryListItem__title', {
          hyphenate: isHyphenatedLocale(),
        })}
      >
        {(industryOrMaterialValues as string[]).includes(categoryItem)
          ? t(`industryOrMaterial.${categoryItem}` as TranslationKey)
          : t(`typeOfTesting.${categoryItem}` as TranslationKey)}
      </span>
    </Link>
  )
}
